module.exports = __webpack_public_path__ + "img/drill.be5030ca.webp";